import CryptoJS from "crypto-js";
import { LertamRCFormat } from "./utils";

const encryptedFetch = (input: string, options: any) => {
  // if (process.env.NODE_ENV !== "production") {
  //   return fetch(input, options);
  // }
  if (typeof options.body !== "string") {
    return fetch(input, options);
  }
  let encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(options.body),
    // TODO Generate password and use it from env
    "password",
    {
      format: LertamRCFormat,
    }
  );
  options.body = encrypted.toString();
  options.headers["content-type"] = "text/plain";
  return fetch(input, options);
};

export default encryptedFetch;
